import React from 'react'
import classes from './Dashboard.module.css'

export default function Dashboard() {
	return (
		<div className={classes.dashboardContainer}>
			<div className={classes.dashboardText}>Cars App</div>
		</div>
	)
}
